export var OfferFilterType;
(function (OfferFilterType) {
    OfferFilterType["type"] = "selectedTypeIds";
    OfferFilterType["location"] = "selectedLocations";
    OfferFilterType["jobArea"] = "selectedJobAreaIds";
})(OfferFilterType || (OfferFilterType = {}));
